/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-04-07 15:05:46
 * @LastEditors: linxi
 * @LastEditTime: 2021-05-31 10:19:04
 */
import { Form, Input, Select, Button, Row, Col, Space } from 'antd'
import React, { useEffect, useState } from 'react'
import { SearchOutlined, CaretDownFilled } from '@ant-design/icons'
import { FieldData } from '../../models/fielddata'
// import { setSupplierState } from "./supplierSlice";
import { useDispatch } from 'react-redux'
import { supplierParams } from '../../services/supplier'
import { setCurrent } from './supplierSlice'
import { DateRangeFieldName, DateRangeType, DateSelect, RecentTimesRealThreeMonths } from '../../compnents/form/DateSelect'
import { useLocation } from 'react-router-dom'
const { Option } = Select

export const SupplierQuery = (props: {
  loading?: any
  onValueChange: (queries: supplierParams) => void
}) => {
  const [form] = Form.useForm()

  const location: any = useLocation()

  const dispatch = useDispatch()

  const DefaultFields: FieldData[] = [
    {
      name: 'name',
      value: undefined,
    },
    {
      name: 'supplierCategory',
      value: undefined,
    },
  ]

  const [fields, setFields] = useState(DefaultFields)

  useEffect(() => {
    if (location?.state?.dueLicence) {
      form.setFieldsValue({
        [DateRangeFieldName]: DateRangeType.HalfAYear,
      })
    }
  }, [location.state])

  return (
    <Form
      fields={fields}
      form={form}
      autoComplete='off'
      name='control-hooks'
      onFinish={(vs) => {
        dispatch(setCurrent(1))
        props.onValueChange(vs)
      }}
    >
      <Row style={{ margin: '0 0 10px 0' }} justify='space-between'>
        <Space wrap={false}>
          <Form.Item name='name' noStyle>
            <Input
              placeholder='供应商名称/助记码'
              allowClear
              prefix={<SearchOutlined />}
              onChange={form.submit}
            />
          </Form.Item>
          <Form.Item name='supplierCategory' noStyle>
            <Select
              placeholder='供应商类别'
              allowClear
              onChange={form.submit}
              // suffixIcon={<CaretDownFilled />}
            >
              <Option value={0}>供应商类别-供应商</Option>
              <Option value={1}>供应商类别-生产厂商</Option>
            </Select>
          </Form.Item>
          <Form.Item name='flag' initialValue={0} noStyle>
            <Select
              placeholder='查询范围'
              onChange={form.submit}
              // suffixIcon={<CaretDownFilled />}
            >
              <Option value={0}>仅查询本机构的供应商</Option>
              <Option value={1}>包含系统自带的默认供应商</Option>
            </Select>
          </Form.Item>
          <DateSelect
            style={{ width: '120px' }}
            placeholder='有效期至'
            allowClear={false}
            labelPrefix=''
            options={RecentTimesRealThreeMonths}
            namePrefix='deadLicence'
            onChange={form.submit}
          />
          <Button
            loading={props?.loading}
            type='primary'
            style={{ float: 'right' }}
            onClick={form.submit}
          >
            查询
          </Button>
        </Space>
      </Row>
    </Form>
  )
}
